import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"
import { Button, ButtonGroup, Form, Modal, Row, Table } from "react-bootstrap"
import Select from "react-select"
import { usePortAlerts } from "../hooks/usePortAlerts"

interface PrevetPortAlertModalProps {
  show: boolean
  handleClose: () => void
}

interface SelectOption {
  label: string
  value: string
}

const PrevetPortAlertModal = ({
  show,
  handleClose,
}: PrevetPortAlertModalProps) => {
  const [selectedOrgIds, setSelectedOrgIds] = useState<string[] | undefined>(undefined)
  const { portAlerts, countriesUNLocode, organizations, createPortAlert, deletePortAlert } = usePortAlerts({ org_ids: selectedOrgIds })

  useEffect(() => {
    if (organizations)
      setSelectedOrgIds(organizations?.map(i => i.id))
  }, [organizations])

  const [selectedCountry, setSelectedCountry] = useState<SelectOption | null>(null)
  const [selectedOrganization, setSelectedOrganization] = useState<SelectOption | null>(null)
  const [isEditing, setIsEditing] = useState(false)
  const [editingCountryId, setEditingCountryId] = useState<number | null>(null)

  /* To be edited */
  const [organizationFilter, setOrganizationFilter] = useState<string>("")

  const handleAddPortAlerts = async () => {
    if (selectedCountry && selectedOrganization) {
      await createPortAlert({ organizationId: selectedOrganization.value, countryUnlocode: selectedCountry.value })
    }
    resetForm()
  }

  const handleDelete = async (id: string) => {
    if (id) {
      await deletePortAlert(id)
    }
  }

  const resetForm = () => {
    setSelectedCountry(null)
    setSelectedOrganization(null)
    setEditingCountryId(null)
    setIsEditing(false)
  }

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Port Alerts - Admin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Form.Label style={{ fontWeight: 700, fontSize: "17px" }}>Add port alerts</Form.Label>
            </Row>
            <Row className="mb-3">
              <div className="w-100 d-flex gap-2">
                <div className="w-100">
                  <Form.Group>
                    {/* <Form.Label className="w-100" style={{ fontWeight: "bold", fontSize: "14px" }}>Organization</Form.Label> */}
                    <Select
                      options={organizations?.map<SelectOption>(org => ({ label: org.display_name, value: org.id } as SelectOption))}
                      value={selectedOrganization}
                      onChange={setSelectedOrganization}
                      className="w-100"
                      placeholder="Select an organization"
                    />
                  </Form.Group>
                </div>
                <div className="w-100">
                  <Form.Group>
                    <Select
                      options={countriesUNLocode}
                      value={selectedCountry}
                      onChange={setSelectedCountry}
                      className="w-100"
                      placeholder="Select a country"
                    />
                  </Form.Group>
                </div>
                <div>
                  <Form.Group className="w-50">
                    <ButtonGroup>
                      <Button
                        variant="primary"
                        onClick={handleAddPortAlerts}
                        disabled={!selectedCountry || !selectedOrganization}
                      >
                        <FontAwesomeIcon icon={faPlus} />
                      </Button>
                    </ButtonGroup>
                  </Form.Group>
                </div>
              </div>
            </Row>
            <Row className="mb-3">
              <Form.Label style={{ fontWeight: 700, fontSize: "17px" }}>List of port alerts</Form.Label>
            </Row>
            <Row className="mb-3">
              <Form.Group className="mb-3">
                <Form.Label style={{ fontWeight: "bold", fontSize: "14px" }}>Filter by</Form.Label>
                <Form.Control
                  as="select"
                  value={organizationFilter}
                  onChange={(e) => setOrganizationFilter(e.target.value)}
                >
                  <option value="">All Organizations</option>
                  {organizations && organizations.map((org) => (
                    <option key={org.id} value={org.id}>
                      {org.display_name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              {!portAlerts || portAlerts.length === 0 ? (
                <p>
                  No added port alerts.
                </p>
              ) : (
                <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                  <Table striped bordered hover style={{ marginBottom: 0 }}>
                    <thead style={{ position: "sticky", top: 0 }}>
                      <tr>
                        <th style={{ fontWeight: "bold", fontSize: "14px" }}>Organization</th>
                        <th style={{ fontWeight: "bold", fontSize: "14px" }}>Country Name</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {portAlerts.filter((pa) => (organizationFilter ? pa.organizationId === organizationFilter : true))
                        .map((pa) => (
                          <tr key={pa.id}>
                            <td>{pa.organization_name}</td>
                            <td>{pa.country_name}</td>
                            <td>
                              <Button
                                variant="danger"
                                size="sm"
                                onClick={() => pa.id && handleDelete(pa.id)}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </Button>{" "}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>

        </Modal.Footer>
      </Modal>
    </>
  )
}

export default PrevetPortAlertModal
